import React from 'react';
import { FormError, HelpText } from '@Forms/fields.jsx';

const TextField = ({
  className,
  error,
  helpText,
  label,
  name,
  placeholder = '',
  register,
  options = {},
  type = 'text',
  ...props
}) => {
  // resuable text field
  return (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-input ` +
        (error ? 'sb-form-item-error' : '') +
        ' ' +
        (className ? className : '')
      }
    >
      {label && <label htmlFor={name}>{label}</label>}
      <div className="sb-form-item-content">
        <input
          type={type}
          placeholder={placeholder}
          aria-invalid={error ? 'true' : 'false'}
          {...register(name, options)}
          {...props}
        />
        {helpText && <HelpText message={helpText} />}
        {error && <FormError message={error.message} />}
      </div>
    </div>
  );
};

export default TextField;
